import { IconPlus, IconMinus } from "./icons";
import styles from "./QtyStepper.module.css";

// Minimal numeric stepper. Used in the OrderSheet rows and OrderReview
// table. Honors a `max` if provided (caps at warehouse stock) but allows
// the input to be cleared to 0 to remove the line.
export default function QtyStepper({
  value = 0,
  onChange,
  min = 0,
  max,
  disabled = false,
  size = "md",
}) {
  function clamp(n) {
    let v = Number.isFinite(n) ? n : 0;
    if (v < min) v = min;
    if (typeof max === "number" && v > max) v = max;
    return v;
  }
  function set(n) { onChange?.(clamp(n)); }

  return (
    <div
      className={[
        styles.box,
        styles[size],
        disabled ? styles.disabled : "",
        value > 0 ? styles.active : "",
      ].join(" ")}
    >
      <button
        type="button"
        onClick={() => set(value - 1)}
        disabled={disabled || value <= min}
        className={styles.btn}
        aria-label="Decrease quantity"
      >
        <IconMinus size={16} />
      </button>
      <input
        type="number"
        inputMode="numeric"
        className={styles.input}
        value={value}
        min={min}
        max={max}
        onChange={(e) => {
          const raw = e.target.value;
          const n = raw === "" ? 0 : parseInt(raw, 10);
          set(Number.isNaN(n) ? 0 : n);
        }}
        onFocus={(e) => e.target.select()}
        disabled={disabled}
        aria-label="Quantity"
      />
      <button
        type="button"
        onClick={() => set(value + 1)}
        disabled={disabled || (typeof max === "number" && value >= max)}
        className={styles.btn}
        aria-label="Increase quantity"
      >
        <IconPlus size={16} />
      </button>
    </div>
  );
}
